import { render } from "./RecordsOrder.vue?vue&type=template&id=74537c8f"
import script from "./RecordsOrder.vue?vue&type=script&lang=js"
export * from "./RecordsOrder.vue?vue&type=script&lang=js"

import "./RecordsOrder.vue?vue&type=style&index=0&id=74537c8f&lang=css"

import exportComponent from "/opt/buildhome/repo/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__